import {
  Sanity$AboutUsDocument,
  Sanity$CampaignPage,
  Sanity$HeroSection,
  Sanity$HomePage,
  Sanity$PackagePage,
  Sanity$PricingPage,
} from '@otovo/shared/types/sanityTypes';

import HeroSection from '../HeroSection/HeroSection';
import SanityPageWrapper from './SanityPageWrapper';

const getPageTitle = (heroSection: Sanity$HeroSection) => {
  if (heroSection.campaignFields?.headline) {
    return heroSection.campaignFields.headline;
  }
  return heroSection.defaultFields?.headline;
};

const getPageDescription = (heroSection: Sanity$HeroSection) => {
  if (heroSection.campaignFields?.lead) {
    return heroSection.campaignFields.lead;
  }
  return heroSection.defaultFields?.lead;
};

type Props = {
  page:
    | Sanity$HomePage
    | Sanity$PackagePage
    | Sanity$PricingPage
    | Sanity$CampaignPage
    | Sanity$AboutUsDocument;
};

const SanityLandingPage = ({ page }: Props) => {
  const mainHardwareType =
    'mainHardwareType' in page ? page.mainHardwareType : 'pv_system';
  return (
    <SanityPageWrapper
      contentRows={page.rows}
      page={page}
      pageTitle={getPageTitle(page.heroSection)}
      pageDescription={getPageDescription(page.heroSection)}
      pageImage={page.heroSection.mainImage}
      renderBeforeRows={
        <HeroSection
          heroSection={page.heroSection}
          mainHardwareType={mainHardwareType}
        />
      }
    />
  );
};

export default SanityLandingPage;
